import { FC } from 'react';
import { useStyles } from './styles';
import { Link } from 'react-router-dom';
import { Paper, Modal } from '@material-ui/core';
import { ReactComponent as LogoIcon } from 'assets/logo.svg';

const AccessDeniedPage: FC = () => {
  const classes = useStyles();
  return (
    <>
      <LogoIcon style={{ marginLeft: '40px', width: '140px', height: '52px' }} className={classes.logo} />
      <Modal className={classes.modal} disablePortal disableEnforceFocus disableAutoFocus open={true}>
        <Paper className={classes.paper} elevation={3}>
          <p className={classes.title}>Access Denied</p>
          <p className={classes.text}>
            <span>
              Access to the page is denied by the administrator. If you have an activated administrator account, then
              you can
            </span>
            <Link className={classes.link} to={'/login'}>{` Sign in `}</Link>
            <span>and change the settings on:</span>
            <p>{`Settings -> End-User General -> Actions`}</p>
          </p>
        </Paper>
      </Modal>
    </>
  );
};

export default AccessDeniedPage;
